/**
 * This file is part of the vue-wechat.
 * @link     : https://zhaiyiming.com/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 EM, Z.
 */
module.exports = require('./1.5.0.js');



//////////////////
// WEBPACK FOOTER
// ./~/vue-wechat/index.js
// module id = 210
// module chunks = 3